import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Button, Modal } from 'components/Base';
import { reduxForm, Field, Form, InjectedFormProps } from 'redux-form';
import Fields from 'components/Fields';
import api from 'api';
import { Notify } from 'utils';

import { compose } from 'ramda';

interface NewProviderModal {
  isModalOpen: boolean;
  closeModal: Function;
}

const NewProviderModal = ({
  isModalOpen,
  closeModal,
  handleSubmit,
  reset
}: NewProviderModal & InjectedFormProps) => {
  const useStyles = makeStyles(() =>
    createStyles({
      modal: {
        width: '500px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }
    })
  );

  const classes = useStyles();

  const onSubmit = (values: any) => {
    api
      .requestNewProvider(values.name, values.comments)
      .then(() => {
        closeModal();
        reset();
        Notify.success('Request sent', `Request was sent successfully`);
      })
      .catch(() => {
        Notify.error('Unknown error', 'Please contact administrator');
      });
  };

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => closeModal()}>
      <BoxWrapper
        title="Request new Portfolio Provider"
        closeModal={() => closeModal()}
      >
        <Form onSubmit={handleSubmit(onSubmit)} className={classes.modal}>
          <div
            style={{ display: 'flex', gap: '1.5rem', flexDirection: 'column' }}
          >
            <Field
              name="name"
              shrink
              fullWidth
              component={Fields.Text}
              label="Providers name"
              validate={[Fields.Validators.required]}
            />
            <Field
              name="comments"
              shrink
              fullWidth
              component={Fields.Text}
              multiline
              minRows={3}
              label="Comments"
              validate={[Fields.Validators.required]}
            />
            We will get in touch with the Portfolio Provider to get them added
            to our MPS Hub.
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button type="button" color="primary" onClick={() => closeModal()}>
              Cancel
            </Button>
            <Button type="submit">Submit</Button>
          </div>
        </Form>
      </BoxWrapper>
    </Modal>
  );
};

export default compose(
  reduxForm({
    form: 'newProviderForm',
    enableReinitialize: true
  })
)(NewProviderModal);
